import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MenuIcon, XIcon, UserIcon } from "lucide-react";
import { Logo } from "./Logo";
import { navLinks } from "../../data/home";
export function Navbar() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 border-b border-transparent bg-canvas/85 backdrop-blur-md" data-id="element-148" data-mp="nu7wfustqit3">
      <nav className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 md:px-8" aria-label="Navigation principale" data-id="element-149" data-mp="11t7hksh4ofki">
        <div className="flex items-center gap-10" data-id="element-150" data-mp="xrvq0hep1k9o">
          <Logo data-id="element-151" data-mp="1bk28491eq1br" />
          <ul className="hidden items-center gap-7 lg:flex" data-id="element-152" data-mp="1bihagajsq29o">
            {navLinks.map(link => <li key={link.label} data-id="element-153" data-mp="16lqv5pftfapb">
                <a href={link.href} className="whitespace-nowrap text-[15px] font-medium text-ink/80 transition-colors duration-150 hover:text-ink" data-id="element-154" data-mp="16miosupuqycy">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </div>

        <div className="hidden items-center gap-2 lg:flex" data-id="element-155" data-mp="3ovnk2gdf71k1">
          <a href="#espace-client" className="flex items-center gap-2 whitespace-nowrap rounded-full px-4 py-2.5 text-[15px] font-medium text-ink transition-colors duration-150 hover:bg-surface" data-id="element-156" data-mp="3ow70ttrc3jwh">
            <UserIcon className="h-4 w-4" aria-hidden="true" data-id="element-157" data-mp="1ol83bsi9ahx" />
            Espace client
          </a>
          <a href="#contact" className="whitespace-nowrap rounded-full bg-ink px-5 py-3 text-[15px] font-medium text-canvas transition-transform duration-150 active:scale-[0.97]" data-id="element-158" data-mp="bp5bol3hyr3b">
            Prendre rendez-vous
          </a>
        </div>

        <button type="button" className="flex h-11 w-11 items-center justify-center rounded-full hover:bg-surface lg:hidden" aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? "Fermer le menu" : "Ouvrir le menu"} onClick={() => setOpen(v => !v)} data-id="element-159" data-mp="kgnnykxbomr4">
          {open ? <XIcon className="h-5 w-5" data-id="element-160" data-mp="2lk6qxsl8sv3x" /> : <MenuIcon className="h-5 w-5" data-id="element-161" data-mp="2lkznk0qhm48c" />}
        </button>
      </nav>

      <AnimatePresence data-id="element-162" data-mp="3092x1k3qny1w">
        {open && <motion.div id="mobile-menu" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-canvas px-5 pb-6 pt-2 lg:hidden" data-id="element-163" data-mp="309vt9r52n55s">
            <ul className="flex flex-col" data-id="element-164" data-mp="3j76qz7b21qj4">
              {navLinks.map(link => <li key={link.label} data-id="element-165" data-mp="3e8ccghk4eo4t">
                  <a href={link.href} onClick={() => setOpen(false)} className="block border-b border-line py-4 text-lg font-medium" data-id="element-166" data-mp="3e9doao8ynenl">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <div className="mt-5 grid grid-cols-2 gap-3" data-id="element-167" data-mp="3vi6i3rktvf9m">
              <a href="#espace-client" onClick={() => setOpen(false)} className="rounded-full border border-line py-3 text-center font-medium" data-id="element-168" data-mp="4bwp3cpvuq5x">
                Espace client
              </a>
              <a href="#contact" onClick={() => setOpen(false)} className="rounded-full bg-ink py-3 text-center font-medium text-canvas" data-id="element-169" data-mp="3qp4vsyiakdg0">
                Rendez-vous
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}